<template>
  <div
    class="box mb-4 certificado-card"
    :class="estadoBorderClass"
  >

    <div class="is-flex is-justify-content-space-between is-align-items-center mb-2">
      <div>
        <p class="has-text-weight-semibold">
          Certificado #{{ certificado.id }}
        </p>
        <p class="is-size-7 has-text-grey">
          Serie: {{ certificado.numero_serie }}
        </p>
      </div>

      <span class="tag is-rounded" :class="estadoTagType">
        {{ certificado.estado }}
      </span>
    </div>

    <hr class="my-2">

    <div class="content is-small">
      <p v-if="certificado.usuario">
        <strong>Titular:</strong>
        {{ certificado.usuario.nombre }} {{ certificado.usuario.apellido }}
      </p>
      <p v-else class="has-text-grey">
        Usuario no disponible
      </p>

      <p>
        <strong>DN:</strong>
        <span class="has-text-grey">
          {{ certificado.dn }}
        </span>
      </p>

      <div class="columns is-mobile">
        <div class="column">
          <strong>Emisión</strong><br>
          {{ formatDate(certificado.fecha_emision) }}
        </div>

        <div class="column">
          <strong>Vencimiento</strong><br>
          {{ formatDate(certificado.fecha_vencimiento) }}
        </div>

        <div class="column">
          <strong>Días restantes</strong><br>
          {{ calcDiasRestantes(certificado.fecha_vencimiento) }}
        </div>
      </div>
    </div>

    <div
      v-if="certificado.por_vencer"
      class="notification is-warning is-light mt-3 is-size-7"
    >
      Este certificado está próximo a vencer
    </div>

  </div>
</template>

<script>
export default {
  name: 'CertificadoCard',

  props: {
    certificado: {
      type: Object,
      required: true
    }
  },

  computed: {
    estadoTagType () {
      switch (this.certificado.estado) {
        case 'vigente':
          return 'is-success'
        case 'pendiente':
        case 'pre-pendiente':
          return 'is-info'
        case 'rechazado':
        case 'revocado':
          return 'is-danger'
        case 'vencido':
          return 'is-dark'
        default:
          return 'is-light'
      }
    },

    estadoBorderClass () {
      switch (this.certificado.estado) {
        case 'vigente':
          return 'border-success'
        case 'pendiente':
        case 'pre-pendiente':
          return 'border-info'
        case 'rechazado':
        case 'revocado':
          return 'border-danger'
        case 'vencido':
          return 'border-dark'
        default:
          return 'border-light'
      }
    }
  },

  methods: {
    calcDiasRestantes (value) {
      if (!value) return '-'

      const hoy = new Date()
      const venc = new Date(value)

      const tiempoDif = venc - hoy
      const diasDif = Math.round(tiempoDif / (1000 * 60 * 60 * 24))

      return diasDif
    },

    formatDate (value) {
      if (!value) return '-'
      return new Date(value).toLocaleDateString('es-AR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.certificado-card {
  border-right: 6px solid transparent;
}

.border-success {
  border-right-color: #48c774; /* Bulma success */
}

.border-info {
  border-right-color: #3298dc;
}

.border-danger {
  border-right-color: #f14668;
}

.border-dark {
  border-right-color: #363636;
}

.border-light {
  border-right-color: #dbdbdb;
}
</style>
